import { useState } from "react";
import Sidebar from "./Sidebar";
import Navbar from "./Navbar";

const Layout = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [collapsed, setCollapsed] = useState(false);       // desktop

  const toggleSidebar = () => setSidebarOpen((s) => !s);
  const closeSidebar = () => setSidebarOpen(false);

  return (
    <div className="flex h-screen overflow-hidden bg-gray-50">
     <Sidebar
        isOpen={sidebarOpen}
        isCollapsed={collapsed}
        onClose={() => setSidebarOpen(false)}
      />

      <div className="flex flex-col flex-1 min-w-0">
      <Navbar
          onToggleSidebar={() => setSidebarOpen(!sidebarOpen)}
          onCollapseSidebar={() => setCollapsed(!collapsed)}
          isCollapsed={collapsed}
        />
        <main className="flex-1 overflow-y-auto px-4 md:px-6 py-4">
          {children}
        </main>
      </div>
    </div>
  );
};

export default Layout;
